import { useEffect, useRef } from 'react';

const DEFAULT_INTERVAL_MS = 30_000;

export function useTourPolling(
  fetchStatus: () => Promise<void>,
  isActive: boolean,
  intervalMs: number = DEFAULT_INTERVAL_MS
): void {
  const fetchRef = useRef(fetchStatus);

  useEffect(() => {
    fetchRef.current = fetchStatus;
  }, [fetchStatus]);

  useEffect(() => {
    if (!isActive) {
      return;
    }

    let intervalId: ReturnType<typeof setInterval> | null = null;

    const runFetch = () => {
      void fetchRef.current();
    };

    const startInterval = () => {
      if (intervalId) {
        return;
      }
      intervalId = setInterval(runFetch, intervalMs);
    };

    const stopInterval = () => {
      if (!intervalId) {
        return;
      }
      clearInterval(intervalId);
      intervalId = null;
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        stopInterval();
        return;
      }
      runFetch();
      startInterval();
    };

    if (document.visibilityState !== 'hidden') {
      startInterval();
    }

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      stopInterval();
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [isActive, intervalMs]);
}
